
export type GetApiCoursesType = typeof GetApiCoursesType[keyof typeof GetApiCoursesType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCoursesType = {
  USER: 'USER',
  ENROLLED: 'ENROLLED',
  POPULAR: 'POPULAR',
  ROADMAP: 'ROADMAP',
  FORYOU: 'FORYOU',
  MY_PUBLISHED: 'MY_PUBLISHED',
} as const;
